import PageHero from '../components/PageHero';

export default function About() {
  const cards = [
    { icon:'🎯', color:'#FF9933', title:'Our Mission', sub:'हमारा मिशन', desc:"Millions of eligible families and businesses never claim the benefits they deserve — simply because they don't know they exist. We bridge that gap, free of charge." },
    { icon:'⚙️', color:'#138808', title:'How We Work', sub:'हम कैसे काम करते हैं', desc:"Our team tracks central and state scheme notifications, verifies eligibility rules, and translates them into a matching engine that shows you the right schemes for your real profile." },
    { icon:'🏛️', color:'#000080', title:'Independent & Unaffiliated', sub:'स्वतंत्र और निष्पक्ष', desc:"We are not a government body. YojanaSaathi is independently operated so our guidance stays free and unbiased for every citizen — always." },
  ];

  return (
    <>
      <PageHero tag="About Us · हम कौन हैं" title="Bridging India's Scheme Awareness Gap" subtitle="भारत की योजना-जागरूकता की खाई को पाटने वाला एक संगठन" from="#000080" to="#1a1a99" />

      <section className="section section-gray">
        <div className="wrap">
          <div className="about-intro">
            <p className="p1">YojanaSaathi is an independent organization. We don't run any scheme ourselves — we help citizens and small businesses find, understand, and apply for government schemes that already exist for them.</p>
            <p className="p2">YojanaSaathi एक स्वतंत्र संगठन है। हम केवल नागरिकों और व्यवसायों को उन सरकारी योजनाओं को खोजने और उनके लिए आवेदन करने में मदद करते हैं।</p>
          </div>

          <div className="about-cards">
            {cards.map(c => (
              <div key={c.title} className="card" style={{ borderTop:`4px solid ${c.color}` }}>
                <div style={{fontSize:30,marginBottom:14}}>{c.icon}</div>
                <h3 style={{fontFamily:'Georgia,serif',fontSize:19,color:'#1A1A2E',marginBottom:4}}>{c.title}</h3>
                <div style={{fontSize:11,color:c.color,fontWeight:700,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:12}}>{c.sub}</div>
                <p style={{fontSize:14,color:'#4A5568',lineHeight:1.62}}>{c.desc}</p>
              </div>
            ))}
          </div>

          <div className="about-org">
            {[['📋 Type','Independent Organisation'],['📅 Operating since','2024'],['🗺️ Reach','28 States · 500+ Schemes Tracked']].map(([k,v])=>(
              <div key={k} className="org-item">
                <span className="k">{k}:</span>
                <span className="v">{v}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
